import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Prodect_1 from '../../../assets/images/home_page_5/product-slider/01.png'
import Prodect_2 from '../../../assets/images/home_page_5/product-slider/02.png'
import Prodect_3 from '../../../assets/images/home_page_5/product-slider/03.png'
import Prodect_4 from '../../../assets/images/home_page_5/product-slider/04.png'
import Prodect_5 from '../../../assets/images/home_page_5/product-slider/05.png'

const prodectSlider = {
    slidesToShow: 5,
    Infinity: true,
    Speed: 2000,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Prodect = () => {
    return (
        <>
            <div id="product-slider-five" className="product-slider-five-main-block">
                <div className="container-fluid">
                    <Slider className="slider product-slider-five-autoplay" {...prodectSlider}>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_1}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_2}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_3}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_4}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_5}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_1}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_2}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-five-block">
                            <div className="item">
                                <img
                                    src={Prodect_3}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Prodect
